import qs from "qs";
import axiosInstance, { version } from "../config/Api";
import { setHeaderLoading, initFooter, setFooterLoading } from "./navActions";
import { SetMetaData } from "./contentActions";

// Re-exporting migrated actions for backward compatibility
export * from "./navActions";
export * from "./contentActions";
export * from "./userActions";

export const setUserPermissionData = (data) => ({
  type: "SET_USER_PERMISSION_DATA",
  payload: data,
});

export const initTopMenuHeader = (data) => ({
  type: "INIT_TOPMENU",
  data,
});

export const getTopMenu = () => {
  return (dispatch) => {
    return axiosInstance
      .get(version + "get/topmenu", qs.stringify())
      .then((res) => {
        if (Object.keys(res.data).length) {
          dispatch(initTopMenuHeader(res.data));
          dispatch(setHeaderLoading(false));
        } else {
          dispatch(setHeaderLoading(false));
        }
        return res.data;
      });
  };
};
export const initRightSiteMenuHeader = (data) => ({
  type: "INIT_RIGHTSITE",
  data,
});

export const getRightSiteMenu = () => {
  return (dispatch) => {
    return axiosInstance
      .get(version + "get/rightmenu", qs.stringify())
      .then((res) => {
        if (Object.keys(res.data).length) {
          dispatch(initRightSiteMenuHeader(res.data));
        }

        return res.data;
      });
  };
};

export const sendContactus = (parms) => {
  return (dispatch) => {
    return axiosInstance
      .post(version + "sendContactus", qs.stringify(parms))
      .then((res) => {
        return res;
      });
  };
};
export const getaQuote = (parms) => {
  return (dispatch) => {
    return axiosInstance
      .post(version + "sendContactus", qs.stringify(parms))
      .then((res) => {
        return res.data;
      });
  };
};

export const getPubFooterSection = () => {
  return (dispatch) => {
    return axiosInstance
      .get(version + "get/pubfooter_navigation")
      .then((res) => {
        if (Object.keys(res.data).length) {
          dispatch(initFooter(res.data));
          dispatch(setFooterLoading(false));
        } else {
          dispatch(setFooterLoading(false));
        }
        return res.data;
      });
  };
};

export const contentAdded = (data, id) => ({
  type: "ADDED_CONTENT",
  data: data,
  id: id,
});

export const contentLoadStatus = (id) => ({
  type: "CONTENT_LOAD_STATUS",
  id: id,
});

export const sectionandContent = (parms) => {
  var string = "";
  var length = Object.entries(parms).length;
  Object.entries(parms).forEach((ele, key) => {
    string += ele[0] + "=" + ele[1];
    if (length - 1 !== key) {
      string += "&";
    }
  });

  return (dispatch) => {
    return axiosInstance
      .get(version + "get/contents?" + string, qs.stringify())
      .then((res) => {
        if (Object.keys(res.data).length) {
          dispatch(contentAdded(res.data, parms.menu_id));
        }
        if (Object.keys(res.data).length === 0) {
          dispatch(contentLoadStatus(parms.menu_id));
        }
        return res;
      });
  };
};

export const initpagename = (data) => ({
  type: "INIT_PAGE_NAME",
  data,
});

export const initPubRoute = (data) => ({
  type: "INIT_PUBLICATION_ROUTES",
  data,
});
export const getPubRoutes = () => {
  return (dispatch) => {
    return axiosInstance
      .get(version + "get/pubroutes", qs.stringify())
      .then((res) => {
        if (res.data.length) {
          dispatch(initPubRoute(res.data));
        }
        return res.data;
      });
  };
};
export const setSearchKey = (search) => ({
  type: "SET_SEARCH_KEY",
  search,
});

export const setAllNavigation = (data) => ({
  type: "INIT_HEADER",
  data,
});

export const getAllNavigation = () => {
  return (dispatch) => {
    return axiosInstance.get(version + "get/all_navigation").then((res) => {
      if (res.data.length) {
        dispatch(setAllNavigation(res.data));
      }
      return res.data;
    });
  };
};

export const initSearchContent = (data) => ({
  type: "INIT_SEARCH_CONTENT",
  data,
});
export const addSearchContent = (data) => ({
  type: "ADD_SEARCH_CONTENT",
  data,
});

export const getsearch = (parms) => {
  var string = "";
  var length = Object.entries(parms).length;
  Object.entries(parms).forEach((ele, key) => {
    string += ele[0] + "=" + ele[1];
    if (length - 1 !== key) {
      string += "&";
    }
  });

  return (dispatch) => {
    return axiosInstance
      .get(version + "get/contentsearch?" + string)
      .then((res) => {
        if (Array.isArray(res.data)) {
          if (parms.initial === true) {
            dispatch(initSearchContent(res.data));
          } else {
            dispatch(addSearchContent(res.data));
          }
        }
        return res.data;
      });
  };
};

export const detailsContent = (data) => ({
  type: "SET_DETAILS_CONTENT",
  data,
});

export const getContentDetails = (parms) => {
  var string = "";
  var length = Object.entries(parms).length;
  Object.entries(parms).forEach((ele, key) => {
    string += ele[1];
    if (length - 1 !== key) {
      string += "&";
    }
  });

  return (dispatch) => {
    return axiosInstance
      .get(version + "get/content-details?" + string)
      .then((res) => {
        dispatch(detailsContent(res.data));
        return res.data;
      });
  };
};

export const SetFaqContentAdded = (data) => ({
  type: "INIT_FAQ_LAYOUT",
  data: data,
});

export const faqLayoutContent = (parms) => {
  return (dispatch) => {
    return axiosInstance
      .get(version + "get/sectionandContent", { params: parms })
      .then(({ data }) => {
        if (Object.keys(data).length) {
          dispatch(SetFaqContentAdded(data));
        }
        return data;
      });
  };
};
export const SetContactusContentAdded = (data) => ({
  type: "INIT_CONTACTUS_LAYOUT",
  data: data,
});

export const contactusLayoutContent = (parms) => {
  return (dispatch) => {
    return axiosInstance
      .get(version + "get/sectionandContent", { params: parms })
      .then(({ data }) => {
        if (Object.keys(data).length) {
          dispatch(SetContactusContentAdded(data));
        }
        return data;
      });
  };
};
export const SetPremiumCalculatorContentAdded = (data) => ({
  type: "INIT_PREMIUM_CALCULATOR_LAYOUT",
  data: data,
});



export const getEvent = () => {
  return (dispatch) => {
    return axiosInstance.get(version + "get/getEvent").then(({ data }) => {
      return data;
    });
  };
};
export const getExploreUpdateContent = (parms) => {
  return (dispatch) => {
    return axiosInstance
      .get(version + "get/getExploreUpdateContent", { params: parms })
      .then(({ data }) => {
        return data;
      });
  };
};

export const pageSectionContent = (parms) => {
  return (dispatch) => {
    return axiosInstance
      .get(version + "get/sectionandContent", { params: parms })
      .then(({ data }) => {
        return data;
      });
  };
};

export const newsSubscribe = (parms) => {
  return (dispatch) => {
    return axiosInstance
      .post(version + "newsSubscribe", qs.stringify(parms))
      .then((res) => {
        return res;
      });
  };
};

export const getAllNewsEvent = (category) => {
  return (dispatch) => {
    return axiosInstance
      .get(version + "get/getAllNewsEvent", { params: { category: category } })
      .then(({ data }) => {
        return data;
      });
  };
};

export const MemberData = () => {
  return (dispatch) => {
    return axiosInstance
      .get(version + "get/council-member")
      .then(({ data }) => {
        return data;
      });
  };
};

export const getAlbums = (parms) => {
  return (dispatch) => {
    return axiosInstance
      .get(version + "get/getAlbums", {
        params: parms,
      })
      .then(({ data }) => {
        return data;
      });
  };
};
export const getGallerys = (parms) => {
  return (dispatch) => {
    return axiosInstance
      .get(version + "get/getgallerys", {
        params: parms,
      })
      .then(({ data }) => {
        return data;
      });
  };
};

export const SetWebNewsCategory = (data) => ({
  type: "INIT_WEB_NEWS_CATEGORY",
  data: data,
});

export const WebNewsCategory = (parms) => {
  return (dispatch) => {
    return axiosInstance
      .get(version + "get/getWebNewsCateogry")
      .then(({ data }) => {
        dispatch(SetWebNewsCategory(data));

        return data;
      });
  };
};
export const SetWebNewsFilter = (data) => ({
  type: "INIT_WEB_NEWS_FILTER",
  data: data,
});

export const WebNewsFilter = (parms) => {
  return (dispatch) => {
    return axiosInstance
      .post(version + "get/getWebNewsFilter", qs.stringify(parms))
      .then(({ data }) => {
        dispatch(SetWebNewsFilter(data));

        if (data.length) {
          dispatch(SetWebNewsFilter(data));
        }

        return data;
      });
  };
};
export const SetGroupOfCommittet = (data) => ({
  type: "INIT_GROUPOF_COMMITTE",
  data: data,
});

export const getGroupOfCommitte = (parms) => {
  return (dispatch) => {
    return axiosInstance
      .get(version + "get/getCommittee", { params: parms })
      .then(({ data }) => {
        dispatch(SetGroupOfCommittet(data));
        if (data.length) {
          dispatch(SetGroupOfCommittet(data));
        }

        const meta_data = {
          meta_title: "Tanin | Committees ",
          meta_description: "",
          meta_keywords: "Tanin, Committees",
        };
        dispatch(SetMetaData(meta_data));

        return data;
      });
  };
};

export const SetSingleOfCommittet = (data) => ({
  type: "INIT_SINGLEOF_COMMITTE",
  data: data,
});

export const getSingleOfCommitte = (parms) => {
  return (dispatch) => {
    return axiosInstance
      .get(version + "get/getCommittee", { params: parms })
      .then(({ data }) => {
        dispatch(SetSingleOfCommittet(data));

        if (data.length) {
          dispatch(SetSingleOfCommittet(data));
        }

        const meta_data = {
          meta_title: "Tanin | " + parms.slug,
          meta_description: "",
          meta_keywords: "Tanin, Committees",
        };
        dispatch(SetMetaData(meta_data));

        return data;
      });
  };
};

export const initModalPopupAds = (data) => ({
  type: "INIT_MODAL_POPUP_ADS",
  data: data,
});

export const getHomePageModal = () => {
  return (dispatch) => {
    return axiosInstance.get(version + "get/modalPopup").then(({ data }) => {
      dispatch(initModalPopupAds(data));
      return data;
    });
  };
};

export const setMemberToken = (token) => ({
  type: "SET_MEMBER_TOKEN",
  data: token,
});

export const addPushWebToken = (requestData) => {
  return (dispatch) => {
    return axiosInstance
      .post(version + "pushwebnitification", qs.stringify(requestData))
      .then(({ data }) => {
        return data;
      });
  };
};

export const getMetaData = (parms) => {
  return (dispatch) => {
  };
};

export const getTermsBasedOnPolicy = (parms) => {
  return (dispatch) => {
    return axiosInstance
      .post(version + "getTermsBasedOnPolicy", qs.stringify(parms))
      .then(({ data }) => {
        return data;
      });
  };
};
export const getSumAssuredValidation = (parms) => {
  return (dispatch) => {
    return axiosInstance
      .post(version + "getSumAssuredValidation", qs.stringify(parms))
      .then(({ data }) => {
        return data;
      });
  };
};
export const getCalculations = (parms) => {
  return (dispatch) => {
    return axiosInstance
      .post(version + "getCalculations", qs.stringify(parms))
      .then(({ data }) => {
        return data;
      });
  };
};


export const productDetails = (parms) => {
  return (dispatch) => {
    return axiosInstance
      .get(version + "get/productDetails", { params: parms })
      .then(({ data }) => {
        return data;
      });
  };
};

export const SetChangeLanguage = (data) => ({
  type: "SET_LANG",
  data: data,
});

export const SetLayoutContentLoad = (data) => ({
  type: "INIT_COMMON_CONTENT",
  data: data,
});

export const layoutContentLoad = (parms) => {
  return (dispatch) => {
    return axiosInstance
      .get(version + "get/sectionandContent", { params: parms })
      .then(({ data }) => {
        if (Object.keys(data).length) {
          dispatch(SetLayoutContentLoad(data));
        }
        return data;
      });
  };
};

export const paymentCustomerValidation = (parms) => {
  return (dispatch) => {
    return axiosInstance
      .post(version + "policy/policy_validation", qs.stringify(parms))
      .then(({ data }) => {
        return data;
      });
  };
};
export const paymentCustomerAmountValidation = (parms) => {
  return (dispatch) => {
    return axiosInstance
      .post(version + "policy/policy_amount_validation", qs.stringify(parms))
      .then(({ data }) => {
        return data;
      });
  };
};

export const getPolicyInvoice = (parms) => {
  return (dispatch) => {
    return axiosInstance
      .post(version + "userpanel/policyinvoice", qs.stringify(parms))
      .then(({ data }) => {
        return data;
      });
  };
};

// Zombie methods with empty implementations kept for reference/backward compatibility
export const CAMemberData = (requestData) => { };
export const memberDetails = (requestData) => { };
export const cpdInfo = (requestData) => { };
export const getCslDheerajapi = (requestData, actionMethod, methodname = "get") => { };
export const CAFirmData = (requestData) => { };
export const userLogin = (requestData) => { };
